import Vue from 'vue';
import Router from 'vue-router';

import TrilhaPssc from '@/views/pssc/Trilha.vue';

Vue.use(Router);

const router = new Router({
    routes: [
        {
            path: '/pssc/trilha/:territorio/visao-trilha/:usuarioKeycloak',
            name: 'TrilhaPsscLyra',
            component: TrilhaPssc
        },
        {
            path: '/pssc/trilha/:territorio/:produtor',
            name: 'TrilhaPsscEmail',
            component: TrilhaPssc
        }
    ]
});

export default router;
